import { render, staticRenderFns } from "./myIssueLook.vue?vue&type=template&id=d8622aea&scoped=true&"
import script from "./myIssueLook.vue?vue&type=script&lang=js&"
export * from "./myIssueLook.vue?vue&type=script&lang=js&"
import style0 from "./myIssueLook.vue?vue&type=style&index=0&id=d8622aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8622aea",
  null
  
)

export default component.exports